import { render, staticRenderFns } from "./CbsHtmlSandbox.vue?vue&type=template&id=1846df52&scoped=true"
import script from "./CbsHtmlSandbox.vue?vue&type=script&lang=js"
export * from "./CbsHtmlSandbox.vue?vue&type=script&lang=js"
import style0 from "./CbsHtmlSandbox.vue?vue&type=style&index=0&id=1846df52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846df52",
  null
  
)

export default component.exports